<div class="header">
  <div class="title">Add Sheet Template</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="addSheetTemplateForm">
  <div class="flex flex-col gt-xs:flex-row mb-3">
    <mat-form-field class="flex-auto">
      <mat-label>Name</mat-label>
      <input matInput [formControlName]="'name'" [autocomplete]="false" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <section class="flex-auto">
      <input #fileUpload type="file" hidden (change)="onImportFileChange($event)" [accept]="fileFormats" required />
      <div class="flex items-center">
        <ts-button color="primary" (click)="fileUpload.click()">
          <mat-icon class="mr-1">attach_file</mat-icon>
          Upload file
        </ts-button>

        <span class="ml-2">{{ addSheetTemplateForm.get('fileControl').value?.name || 'No file uploaded yet.' }}</span>
      </div>

      <p class="text-sm mt-2">
        Accepted formats are <strong>{{ fileFormats.join(', ') }}</strong
        >.
      </p>
    </section>
  </div>

  <div class="actions justify-end">
    <div class="buttons">
      <button class="discard-button" mat-button (click)="discard()" type="button">
        <span>Cancel</span>
      </button>
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="addSheetTemplateForm.pristine || addSheetTemplateForm.invalid"
        (click)="saveAndClose()"
      >
        <span *ngIf="!addSheetTemplateForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="addSheetTemplateForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
